import React, { useEffect, useState } from 'react';

function AdminInstallPWA({ isAdminRoute }) {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallPrompt, setShowInstallPrompt] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      window.__ivaDeferredInstallPrompt = event;
      setDeferredPrompt(event);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    // Reuse an install event captured earlier by another screen/component.
    if (window.__ivaDeferredInstallPrompt) {
      setDeferredPrompt(window.__ivaDeferredInstallPrompt);
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  useEffect(() => {
    if (!isAdminRoute) {
      setShowInstallPrompt(false);
      return;
    }

    if (window.matchMedia('(display-mode: standalone)').matches) {
      setShowInstallPrompt(false);
      return;
    }

    if (deferredPrompt) {
      setShowInstallPrompt(true);
    }
  }, [deferredPrompt, isAdminRoute]);

  const handleInstallClick = async () => {
    if (!deferredPrompt) {
      return;
    }

    deferredPrompt.prompt();
    await deferredPrompt.userChoice;

    window.__ivaDeferredInstallPrompt = null;
    setDeferredPrompt(null);
    setShowInstallPrompt(false);
  };

  const handleDismiss = () => {
    setShowInstallPrompt(false);
  };

  if (!isAdminRoute || !showInstallPrompt) {
    return null;
  }

  return (
    <div className="fixed bottom-24 md:bottom-6 left-4 right-4 md:left-auto md:right-6 md:max-w-sm z-50">
      <div className="rounded-xl shadow-2xl border border-slate-600 bg-slate-800 text-white p-4">
        <div className="flex items-start gap-3" dir="rtl">
          <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-slate-700 flex items-center justify-center">
            <svg className="w-6 h-6 text-cyan-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
            </svg>
          </div>

          <div className="flex-1 min-w-0 text-right">
            <h3 className="text-sm font-bold text-slate-100 mb-1">تطبيق لوحة الإدارة</h3>
            <p className="text-xs text-slate-300 mb-3 leading-relaxed">
              ثبّت نسخة الإدارة للوصول السريع للطلبات والمنتجات وإدارة المتجر.
            </p>

            <div className="flex gap-2">
              <button
                onClick={handleDismiss}
                className="flex-1 px-3 py-2 text-xs font-medium text-slate-200 bg-slate-700 rounded-lg hover:bg-slate-600 transition-colors"
              >
                لاحقاً
              </button>
              <button
                onClick={handleInstallClick}
                className="flex-1 px-3 py-2 text-xs font-medium text-slate-900 bg-cyan-300 rounded-lg hover:bg-cyan-200 transition-colors"
              >
                تثبيت الإدارة
              </button>
            </div>
          </div>

          <button
            onClick={handleDismiss}
            className="flex-shrink-0 text-slate-400 hover:text-slate-200 transition-colors"
            aria-label="إغلاق"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}

export default AdminInstallPWA;